import React, { useState, useEffect } from "react";
import { MessageCircle, X } from "lucide-react";
import { COMPANY } from "../mock";

const WhatsAppButton = () => {
  const [show, setShow] = useState(false);
  const waLink = `https://wa.me/${COMPANY.whatsappRaw}?text=${encodeURIComponent(
    COMPANY.whatsappMsg
  )}`;

  useEffect(() => {
    const t = setTimeout(() => setShow(true), 1200);
    return () => clearTimeout(t);
  }, []);

  return (
    <div
      className={`fixed bottom-6 right-6 z-50 transition-all duration-500 ${
        show ? "translate-y-0 opacity-100" : "translate-y-6 opacity-0"
      }`}
    >
      <a
        href={waLink}
        target="_blank"
        rel="noopener noreferrer"
        className="group flex items-center gap-3 rounded-full bg-green-500 py-2.5 pl-2.5 pr-5 text-white shadow-xl shadow-green-500/40 transition-all duration-300 hover:-translate-y-1 hover:bg-green-600 hover:shadow-2xl"
        aria-label="WhatsApp"
      >
        <span className="relative flex h-11 w-11 items-center justify-center rounded-full bg-white/20">
          <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-white/30" />
          <MessageCircle size={24} className="relative" />
        </span>
        <span className="hidden flex-col leading-tight sm:flex">
          <span className="text-xs font-medium text-green-50">WhatsApp · réponse rapide</span>
          <span className="text-sm font-bold">{COMPANY.whatsapp}</span>
        </span>
      </a>
    </div>
  );
};

export default WhatsAppButton;
